import { ChangeDetectionStrategy, Component, computed, ElementRef, input, ViewChild } from '@angular/core';
import { DEFAULT_TEETH, Tooth } from '@libs/ui-lib';
import { TeethComponent } from '@libs/perio';

@Component({
  selector: 'lib-perio-tooth',
  templateUrl: 'perio-tooth.component.html',
  styleUrls: ['./perio-tooth.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TeethComponent],
})
export class PerioToothComponent {
  @ViewChild('chart', { static: true }) public chartElement: ElementRef | undefined;
  @ViewChild(TeethComponent) public perioChart!: TeethComponent;

  public readonly tooth = input.required<Tooth>();
  public readonly isToothMissing = input(false);
  public readonly toothOnly = input(false);
  public readonly isPerioHistoryView = input(false);
  public readonly drawLabels = input(false);
  public readonly viewWidth = input<number>();

  public displayedTeeth = computed(() => {
    return DEFAULT_TEETH.map((tooth) => {
      if (tooth.position === this.tooth().position) {
        return {
          ...this.tooth(),
        };
      }
      return {
        ...tooth,
        treatments: [
          {
            removeTooth: true,
          },
        ],
      } as Tooth;
    });
  });
  private readonly defaultTeeth = DEFAULT_TEETH;
}
